// Cloud Run サービス設定

export interface CloudRunEndpoints {
  ragStream: string;
  deepReasoning: string;
  crawlerService: string;
  speechToText: string;
}

/**
 * Cloud Run エンドポイント設定を取得
 */
export function getCloudRunEndpoints(): CloudRunEndpoints {
  const isDev = import.meta.env.MODE === 'development';

  const ragStreamUrl = isDev
    ? '/proxy-rag-stream'
    : (import.meta.env.VITE_RAG_STREAM_URL || 'https://rag-stream-service-1071908715727.us-central1.run.app');

  const deepReasoningUrl = isDev
    ? '/proxy-deep-reasoning'
    : (import.meta.env.VITE_DEEP_REASONING_URL || 'https://deep-reasoning-service-1071908715727.us-central1.run.app');

  const crawlerServiceProdDefault = 'https://crawler-service-1071908715727.us-central1.run.app';
  const crawlerServiceDevDefault = 'https://crawler-service-dev-1071908715727.us-central1.run.app';

  const crawlerServiceUrl = isDev
    ? (import.meta.env.VITE_CRAWLER_SERVICE_DEV_URL
        || import.meta.env.VITE_CRAWLER_SERVICE_URL
        || crawlerServiceDevDefault)
    : (import.meta.env.VITE_CRAWLER_SERVICE_URL || crawlerServiceProdDefault);

  const speechToTextUrl =
    import.meta.env.VITE_SPEECH_TO_TEXT_URL ||
    'https://speech-to-text-service-1071908715727.us-central1.run.app';

  return {
    ragStream: ragStreamUrl,
    deepReasoning: deepReasoningUrl,
    crawlerService: crawlerServiceUrl,
    speechToText: speechToTextUrl
  };
}

/**
 * 特定のCloud Runサービスのエンドポイントを取得
 */
export function getCloudRunEndpoint(service: 'ragStream' | 'deepReasoning' | 'crawlerService'): string {
  const endpoints = getCloudRunEndpoints();
  return endpoints[service];
}

/**
 * Speech-to-Text Cloud Run エンドポイントを取得
 */
export function getSpeechToTextEndpoint(): string {
  return getCloudRunEndpoints().speechToText;
}
